import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { DatabaseBackup, ArrowRight, CheckCircle2 } from "lucide-react";
import { BACKEND_URL } from "@/lib/backendUrl";

const API = `${BACKEND_URL}/api`;

// Shown on backup days (1st & 15th by default) until the email has gone out / owner has exported
export default function BackupReminder() {
  const [s, setS] = useState(null);
  useEffect(() => { axios.get(`${API}/backup/status`).then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s || !s.due_today) return null;
  if (s.sent_today) {
    return (
      <div className="flex items-center gap-2 rounded-xl border border-emerald-500/30 bg-emerald-500/5 px-4 py-2.5 text-sm text-emerald-200" data-testid="backup-reminder-done">
        <CheckCircle2 className="w-4 h-4" /> Today's data backup was emailed automatically. <Link to="/backup" className="underline underline-offset-2 ml-auto text-xs">View</Link>
      </div>
    );
  }
  return (
    <Link to="/backup" data-testid="backup-reminder" className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-sky-500/40 bg-sky-500/10 px-4 py-3 hover:bg-sky-500/15 transition-colors">
      <DatabaseBackup className="w-5 h-5 text-sky-300 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-sky-100">Backup day — export your data <span className="font-zh text-xs text-sky-300/80">今日备份提醒</span></div>
        <div className="text-xs text-sky-200/70">{s.email_configured ? `The email backup will send automatically after ${s.hour}:00. You can also download the CSV files now.` : "Download the Customers, Quotes and Settings CSV files, or set up the automatic email backup."}</div>
      </div>
      <span className="text-xs font-semibold text-sky-200 flex items-center gap-1 shrink-0">Open Backup <ArrowRight className="w-3.5 h-3.5" /></span>
    </Link>
  );
}
